import { gql } from "@apollo/client";

export const RESET_PASSWORD = gql`
  mutation ResetPassword($input: InputResetPassword!) {
    resetPassword(input: $input) {
      id
    }
  }
`;
